import richText from "utilities/richText"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import JotFormEmbed from "components/JotFormEmbed"

export default function FormEmbedSection({ blok: { intro_content, form_url } }) {
  return (
    <section className="bg-springWood py-16">
      <div className="mx-auto max-w-screen-xl px-6">
        <div className="prose mx-auto lg:prose-lg prose-h2:mb-6 prose-h2:text-center prose-h2:text-l3 prose-h2:text-teal-dark lg:prose-h2:text-xl1">
          {richText(intro_content)}
          <div className="iframe-wrapper">
            <JotFormEmbed formURL={getStoryblokLink(form_url)} heightOffset={30} />
          </div>
        </div>
      </div>
    </section>
  )
}
